import { Card, withStyles, WithStyles } from '@material-ui/core';
import React from 'react';

import { Checkbox } from '@shared/components/checkbox';
import { Flex } from '@shared/components/flex';
import { MixedUser, UserMultiLookup } from '@shared/components/lookups/user-lookup';
import { t } from '@shared/i18n';
import { TransactionType } from '@shared/models/transactions/transactions';
import { InputSize } from '@shared/types/common/input';

import { styles } from './AgencyRoleSection.styles';

interface AgencyRoleSectionProps extends WithStyles<typeof styles> {
  transactionType: TransactionType;
  ourDisposal: boolean;
  ourAcquisition: boolean;
  ourDisposalError?: boolean;
  landlordAgents: MixedUser[];
  tenantAgents: MixedUser[];
  onOurDisposalChange: (checked: boolean) => void;
  onOurAcquisitionChange: (checked: boolean) => void;
  onLandlordAgentsChange: (agents: MixedUser[]) => void;
  onTenantAgentsChange: (agents: MixedUser[]) => void;
}

const AgencyRoleSectionComponent: React.FC<AgencyRoleSectionProps> = ({
  classes,
  transactionType,
  ourDisposal,
  ourAcquisition,
  ourDisposalError = false,
  landlordAgents,
  tenantAgents,
  onOurDisposalChange,
  onOurAcquisitionChange,
  onLandlordAgentsChange,
  onTenantAgentsChange,
}) => {
  return (
    <Card elevation={0} classes={{ root: classes.card }}>
      <Flex justifyContent="flex-start" className={classes.cardHeader}>
        <span className={classes.cardTitle}>{t('your_agency_role')}</span>
      </Flex>
      <Flex direction="row" className={classes.radioRoot}>
        <Checkbox
          error={ourDisposalError}
          label={t('our_disposal')}
          checked={ourDisposal}
          onChange={(checked) => onOurDisposalChange(checked)}
          classes={{ root: classes.radioWrapper }}
        />
        <Checkbox
          error={ourDisposalError}
          label={t('our_acquisition')}
          checked={ourAcquisition}
          onChange={(checked) => onOurAcquisitionChange(checked)}
          classes={{ root: classes.radioWrapper }}
        />
      </Flex>

      <div className={classes.lookupSection}>
        {ourDisposal && (
          <UserMultiLookup
            inputProps={{ size: InputSize.medium }}
            label={transactionType === TransactionType.lettings ? t('landlord_agent_s') : t('vendor_agent_s')}
            value={landlordAgents}
            onChange={onLandlordAgentsChange}
          />
        )}

        {ourAcquisition && (
          <UserMultiLookup
            inputProps={{ size: InputSize.medium }}
            label={transactionType === TransactionType.lettings ? t('tenant_agent_s') : t('purchaser_agent_s')}
            value={tenantAgents}
            onChange={onTenantAgentsChange}
          />
        )}
      </div>
    </Card>
  );
};

export const AgencyRoleSection = withStyles(styles)(AgencyRoleSectionComponent);
